var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F4FFEC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_5861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4998 42.5C26.4998 43.2333 27.0998 43.8333 27.8332 43.8333H33.1665C33.8998 43.8333 34.4998 43.2333 34.4998 42.5V41.1666H26.4998V42.5ZM30.4998 17.1666C25.3532 17.1666 21.1665 21.3533 21.1665 26.5C21.1665 29.6733 22.7532 32.46 25.1665 34.1533V37.1666C25.1665 37.9 25.7665 38.5 26.4998 38.5H34.4998C35.2332 38.5 35.8332 37.9 35.8332 37.1666V34.1533C38.2465 32.46 39.8332 29.6733 39.8332 26.5C39.8332 21.3533 35.6465 17.1666 30.4998 17.1666ZM33.1665 32.7666V35.8333H27.8332V32.7666C25.8065 31.34 23.8332 29.8733 23.8332 26.5C23.8332 22.82 26.8198 19.8333 30.4998 19.8333C34.1798 19.8333 37.1665 22.82 37.1665 26.5C37.1665 29.82 35.1532 31.3666 33.1665 32.7666Z",
    fill: "#68AD3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_5861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14.5 14.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartIcon);
export default __webpack_public_path__ + "static/media/smart-icon.3e368125a9e06219e917c411cdef8ce1.svg";
export { ForwardRef as ReactComponent };